import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Stopwatch = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.5H14C14.6 4.5 15 4.1 15 3.5C15 2.9 14.6 2.5 14 2.5H10C9.4 2.5 9 2.9 9 3.5C9 4.1 9.4 4.5 10 4.5ZM18.3 8.6L19.2 7.7C19.6 7.3 19.6 6.7 19.2 6.3C18.8 5.9 18.2 5.9 17.8 6.3L16.9 7.2C14 4.9 10 4.9 7.1 7.2L6.2 6.3C5.8 5.9 5.2 5.9 4.8 6.3C4.4 6.7 4.4 7.3 4.8 7.7L5.7 8.6C3 12.1 3.6 17.1 7.1 19.8C10.6 22.5 15.6 21.9 18.3 18.4C20.6 15.5 20.6 11.5 18.3 8.6ZM13.7 14.5C13.3 15.1 12.7 15.5 12 15.5C10.9 15.5 10 14.6 10 13.5C10 12.8 10.4 12.1 11 11.8V9.5C11 8.9 11.4 8.5 12 8.5C12.6 8.5 13 8.9 13 9.5V11.8C14 12.3 14.3 13.5 13.7 14.5Z"
      fill="currentColor"
    />
  </svg>
)

export default Stopwatch
